export class LayoutMapConfigModel
{
    listDevice?:{
        baseData?:{
            icon:boolean;
            duration:boolean;
            speed:boolean;
            battery:boolean;
            gsm:boolean;
        },
        deviceData?:{
            numberPlate:boolean;
            imei:boolean;
            simno:boolean;
            vin:boolean;
            powerVoltage:boolean;
            distanceToday:boolean;
            driver:boolean;
            drivingToday:boolean;
            updateTime:boolean;
            group:boolean;
            geofence:boolean;
            address:boolean;
        }
    };
    listDeviceBase?:{
        baseData?:{
            icon:boolean;
            duration:boolean;
            speed:boolean;
            battery:boolean;
            gsm:boolean;
        },
        deviceData?:{
            numberPlate:boolean;
            imei:boolean;
            simno:boolean;
            vin:boolean;
            powerVoltage:boolean;
            distanceToday:boolean;
            driver:boolean;
            drivingToday:boolean;
            updateTime:boolean;
            group:boolean;
            geofence:boolean;
            address:boolean;
        }
    };
    infoDeviceMulti?:{
        baseData?:{
            isShow:boolean;
            showFull:boolean;
        },
        deviceData?:{
            numberPlate:boolean;
            imei:boolean;
            simno:boolean;
            vin:boolean;
            gsm:boolean;
            duration:boolean;
            powerVoltage:boolean;
            battery:boolean;
            distanceToday:boolean;
            driver:boolean;
            drivingToday:boolean;
            updateTime:boolean;
            group:boolean;
            geofence:boolean;
            address:boolean;
        }
    };
    infoDevice?:{
        baseData?:{
            icon:boolean;
            duration:boolean;
            speed:boolean;
            battery:boolean;
            gsm:boolean;
        },
        deviceData?:{
            numberPlate:boolean;
            imei:boolean;
            simno:boolean;
            vin:boolean;
            powerVoltage:boolean;
            distanceToday:boolean;
            driver:boolean;
            drivingToday:boolean;
            updateTime:boolean;
            group:boolean;
            geofence:boolean;
            address:boolean;
        },
        lastDay:{
            distance:boolean;
            driving:boolean;
            stop:boolean;
        },
        other:{
            air:boolean;
            door:boolean;
            engine:boolean;
            ben:boolean;
        }
    };
    tracking?:{
        info:{
            baseData?:{
                icon:boolean;
                duration:boolean;
                speed:boolean;
                battery:boolean;
                gsm:boolean;
            },
            deviceData?:{
                numberPlate:boolean;
                imei:boolean;
                simno:boolean;
                vin:boolean;
                powerVoltage:boolean;
                distanceToday:boolean;
                driver:boolean;
                drivingToday:boolean;
                updateTime:boolean;
                group:boolean;
                geofence:boolean;
                address:boolean;
            },
            lastDay:{
                distance:boolean;
                driving:boolean;
                stop:boolean;
            },
            other:{
                air:boolean;
                door:boolean;
                engine:boolean;
                ben:boolean;
            }
        },
        route:{
            summary:{
                distance:boolean;
                driving:boolean;
                stop:boolean;
            }
        },
        chart:{

        }
    };
}